
import ShowText from './showtext.vue';
export {ShowText};


// WEBPACK FOOTER //
// ./src/components/label/index.js